import React, { useEffect, useState } from "react";
import Icons from "../../myIcon/Icons";
import { BaseUrl } from "../../helper/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function KitchenConsultation({ data }) {
    const navigate = useNavigate();
    const [ip, setIp] = useState("");
    const [loading, setLoading] = useState(false);

    const [postData, setPostData] = useState({ name: "", email: "", mobile: "", location: "", what_planning: "", when_start: "", messages: "", source_url: sessionStorage.getItem("first_landing_url"), ip_address: ip, });

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Validation for Name field
        if (name === "name") {
            // Allow only alphabets and spaces
            const filteredValue = value.replace(/[^A-Za-z\s]/g, "");

            setPostData((prev) => ({
                ...prev,
                [name]: filteredValue,
            }));

            return;
        }

        // Validation for Mobile field
        if (name === "mobile") {
            // Allow only numbers
            const filteredValue = value.replace(/\D/g, "");

            setPostData((prev) => ({
                ...prev,
                [name]: filteredValue,
            }));

            return;
        }

        setPostData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        // Get IP address on component load
        const fetchIp = async () => {
            const res = await fetch("https://api.ipify.org?format=json");
            const data = await res.json();
            setIp(data.ip);
        };
        fetchIp();
    }, []);

    // Submit handler
    const handleSubmit = async (e) => {
        e.preventDefault();

        for (const [key, value] of Object.entries(postData)) {
            if (
                key !== "source_url" &&
                key !== "ip_address" &&
                (value === "" || value === null)
            ) {
                toast.error(`The field "${key}" is mandatory.`);
                return;
            }
        }

        if (!/^[A-Za-z\s]+$/.test(postData.name)) {
            toast.error("Name should contain only alphabets.");
            return;
        }

        if (!/^[0-9]+$/.test(postData.mobile)) {
            toast.error("Phone Number should contain only digits.");
            return;
        }

        if (postData.mobile.length !== 10) {
            toast.error("Phone Number should be exactly 10 digits long.");
            return;
        }

        const payload = {
            ...postData,
            ip_address: ip,
            source_url: sessionStorage.getItem("first_landing_url"),
        };

        setLoading(true);

        try {
            await axios.post(`${BaseUrl}/api/contact-saves`, payload);
            navigate("/thankyou");
        } catch (error) {
            console.error("Error submitting form:", error);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>

            <section className='kitchen-consultation-area'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-6 col-md-6 order-2 order-md-1 order-lg-1'>
                            <div className='kitchen-consultation-grid'>
                                {
                                    data.features.map((item, index) => (
                                        <div className='consultation-item' key={index} >
                                            <img src={item.icon} alt={item.title} />
                                            <span dangerouslySetInnerHTML={{ __html: item.title }}></span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div className='col-lg-6 col-md-6 order-1 order-md-2 order-lg-2'>
                            <div className='kitchen-consultation-form'>
                                <h2 className='heading'>
                                    {data.formTitle}
                                </h2>
                                <p>{data.formDescription} </p>

                                <form onSubmit={handleSubmit}>
                                    <div className='row'>
                                        <div className='col-lg-6'>
                                            <div className='form-group'>
                                                <input type='text' value={postData.name} onChange={handleChange} name="name" required className='form-control' placeholder='Your Name' />
                                            </div>
                                        </div>

                                        <div className='col-lg-6'>
                                            <div className='form-group'>
                                                <input type='email' value={postData.email} onChange={handleChange} name="email" required className='form-control' placeholder='Email' />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-lg-6'>
                                            <div className='form-group'>
                                                <input type="tel" value={postData.mobile} onChange={handleChange} required name="mobile" maxLength={10} className='form-control' placeholder='Phone' />
                                            </div>
                                        </div>

                                        <div className='col-lg-6'>
                                            <div className='form-group'>
                                                <input value={postData.location} onChange={handleChange} type="text" name="location" placeholder="City" className="form-control" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='form-group select-group'>
                                        <select className='form-control' value={postData.what_planning} onChange={handleChange} required name="what_planning" >
                                            <option value="" disabled>What Are You Planning?</option>
                                            <option value="New home kitchen">New home kitchen</option>
                                            <option value="Kitchen renovation">Kitchen renovation</option>
                                            <option value="Wardrobe">Wardrobe</option>
                                            <option value="Full home interiors">Full home interiors</option>
                                            <option value="Other">Other</option>
                                        </select>
                                        <span className='select-arrow'>
                                            <Icons name="arrowDown" />
                                        </span>
                                    </div>

                                    <div className='form-group select-group'>
                                        <select className='form-control' value={postData.when_start} onChange={handleChange} required name="when_start" >
                                            <option value="" disabled>When Are You looking to start?</option>
                                            <option value="Within 1 month">Within 1 month</option>
                                            <option value="1-3 months">1-3 months</option>
                                            <option value="3-6 months">3-6 months</option>
                                            <option value="Just exploring">Just exploring</option>
                                        </select>
                                        <span className='select-arrow'>
                                            <Icons name="arrowDown" />
                                        </span>
                                    </div>

                                    <div className='form-group'>
                                        <textarea value={postData.messages} onChange={handleChange} name="messages" className='form-control' placeholder='Your Message' ></textarea>
                                    </div>

                                    <button type="submit" className="default-btn colored-btn">
                                        {loading ? "submitting..." : "Book A Free Consultation"}
                                        <Icons name="Longarrow_right" />
                                    </button>

                                    <ul className="addconsult-points">
                                        <li><img src="/image/star-icon.webp" alt="star"/>Direct Manufacturer</li>
                                        <li><img src="/image/star-icon.webp" alt="star"/>No Middleman Cost</li>
                                        <li><img src="/image/star-icon.webp" alt="star"/>Gurgaon Based</li>
                                    </ul>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}